(function () {
  var END = Date.parse('2026-09-14T23:59:59+05:30');

  function hideEnded() {
    if (!END || Date.now() < END) return;
    document.querySelectorAll('[data-habba-end]').forEach(function (el) {
      el.classList.add('is-ended');
    });
  }

  hideEnded();
  document.addEventListener('shopify:section:load', hideEnded);
})();
